import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review from Beefy's Own's live Faire brand page
// (`GET /api/brand/reviews/b_d6aqh4qdhb`, review token br_gtecnw2yc9) —
// reviewer first name, location, star rating and text are verbatim. The date
// is the review's `publish_at` (what the live page shows), not `created_at`.
//
// Purchased products: the public brand-reviews endpoint returns only a
// `brand_order_token`, not the order's line items, so the exact per-review
// product set isn't resolvable from it. The brand's entire catalog is 5 SKUs,
// and the live page shows this review with 4 purchased bags, so this pairs it
// with 4 real product tokens from that catalog. Same approach as the Sweet
// Wink brand reviews already in entity-db (see review_sw9).
export const review_bo1: FaireReviewEntity = {
  token: "review_bo1",
  type: "review",
  brandName: "Beefy's Own",
  brandToken: "b_d6aqh4qdhb",
  reviewerName: "Kasie",
  reviewerLocation: "San Francisco, CA, United States",
  stars: 5,
  reviewText: "Everyone loves these!! ❤️",
  reviewDate: "Aug 7, 2026",
  reviewType: "brand",
  purchasedProductTokens: [
    "p_6sy6atfkhp",
    "p_b7tqfj6z9q",
    "p_tuu6txxtve",
    "p_vaba25wx8e",
  ],
  meta: {
    source: "api",
    importedAt: "2026-08-16T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
